import { TitleText } from '@calendly/ui/components/typography'

import { GmailConfirmation } from 'components/confirmation/gmail_confirmation'
import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import {
  ConfirmationDetails,
  Container,
  ConfirmationFooter,
  ConfirmationHeader,
  CookieSettingsButton,
} from 'components/confirmation/layout'

const Header = () => {
  const { title, subtitle, shouldSeeGmailSniperLink } = useConfirmationPageData()

  return (
    <ConfirmationHeader>
      <TitleText level={2} as="h1" size="large">
        {title}
      </TitleText>
      {subtitle}
      {shouldSeeGmailSniperLink && <GmailConfirmation />}
    </ConfirmationHeader>
  )
}

export const ConfirmationPage = () => (
  <Container>
    <Header />
    <ConfirmationDetails />
    <ConfirmationFooter />
    <CookieSettingsButton />
  </Container>
)
